






























































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { METHODS } from '@/constants/payment';

@Component({
  computed: {
    ...mapState('Auth', {
      candidate: 'candidate',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderCreateOrderReviewTable extends Vue {
  paymentMethods = METHODS;

  candidate!: Model;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;

  prepaidHeaders = [
    {
      text: 'Service Item',
      value: 'name',
    },
    {
      text: 'Requested Quantity',
      value: '_requested_quantity',
    },
    {
      text: 'Unit Price',
      value: 'unit_price',
    },
    {
      text: 'Subtotal',
      value: 'unit_price',
    },
  ];

  invoiceHeaders = [
    {
      text: 'Service Item',
      value: 'name',
    },
    {
      text: 'Top up Quantity',
      value: '_available_quantity',
    },
  ];

  discount(item) {
    const discount =
      ((Number(item.unit_price) - Number(item._unit_price)) /
        Number(item.unit_price)) *
      100;
    return discount + '% off';
  }
}
